import { Table, Input, ConfigProvider } from 'antd';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { API_ENDPOINTS } from '../../assets/api/endpoints';
import './Currency.scss';
import Header from '../../components/Header/Header';
import { SearchOutlined } from '@ant-design/icons';
import axios from 'axios';
import { CountryAndPaymentMethodFilters } from '../../models/CountryAndPaymentMethod';
import { getCurrencyColumn } from '../../helpers/CurrencyColumn';
import { currency } from '../../models/currency';
import { themeConfig } from '../WalletTransactions/config';
import { StyledPagination } from '../../components/table.style';
import { useConfigurationContext } from '../../store/configurationContext';

const Currency = () => {
	const { t } = useTranslation();
	const [currencyLoading, setCurrencyLoading] = useState(false);
	const [currencies, setCurrencies] = useState([]);
	const [sortBy, setSortBy] = useState<string>('');
	const [pageSize, setPageSize] = useState(10);
	const [page, setPage] = useState(0);
	const [totalElements, setTotalElements] = useState(0);
	const [searchTerm, setSearchTerm] = useState('');
	const [searchValue, setSearchValue] = useState('');
	const { configurationState } = useConfigurationContext();
	const themeColor = configurationState.find((item) => item.configKey === 'theme_color')?.value || '';
	const secondary_color = configurationState.find((item) => item.configKey === 'secondary_color')?.value || '';
	useEffect(() => {
		setCurrencyLoading(true);
		axios
			.get(`${API_ENDPOINTS.currency}`)
			.then((res) => {
				const sortedData = res.data
					.sort((a: any, b: any) => {
						switch (sortBy) {
							case CountryAndPaymentMethodFilters.currencyCodeAsc:
								return a.currencyCode.localeCompare(b.currencyCode);
							case CountryAndPaymentMethodFilters.currencyCodeDesc:
								return b.currencyCode.localeCompare(a.currencyCode);
							case CountryAndPaymentMethodFilters.isPublicAsc:
								return a.isPublic - b.isPublic;
							case CountryAndPaymentMethodFilters.isPublicDesc:
								return b.isPublic - a.isPublic;
							default:
								return 0;
						}
					})
					.filter((obj: any) =>
						Object.values(obj).some(
							(val: any) => val?.toString().toLocaleLowerCase().includes(searchValue.toString().toLocaleLowerCase()),
						),
					);
				setCurrencies(sortedData);
				setTotalElements(sortedData.length);
			})
			.catch((err) => console.error(err))
			.finally(() => setCurrencyLoading(false));
	}, [sortBy, searchValue]);

	useEffect(() => {
		const delaySearch = setTimeout(() => {
			setSearchValue(searchTerm);
		}, 1000);
		return () => clearTimeout(delaySearch);
	}, [searchTerm]);

	useEffect(() => {
		setPage(0);
		setPageSize(10);
	}, [searchValue]);

	const highlightRow = (record: currency) => {
		return record.isDefault ? 'highlighted-row' : '';
	};

	return (
		<div className='currencies-container'>
			<Header title={t<string>('Currency')} description={t<string>('CurrencySubtitle')} />
			<div className='min-h-[84vh] p-5 bg-white '>
				<div className='flex justify-end items-center my-2'>
					<Input
						className='border-none h-10 bg-[#F5F5F5] search-input w-[200px] xss:my-4 lg:my-0'
						placeholder={t<string>('search')}
						value={searchTerm}
						onChange={(e) => {
							setSearchTerm(e.target.value);
						}}
						size='large'
						prefix={<SearchOutlined className='mr-2' />}
					/>
				</div>
				<ConfigProvider theme={themeConfig}>
					<StyledPagination bgColor={themeColor} color={secondary_color}>
						<Table
							columns={getCurrencyColumn(t, sortBy, setSortBy)}
							dataSource={currencies}
							pagination={{
								pageSize,
								total: totalElements,
								onChange: (pageIndex) => setPage(pageIndex - 1),
								current: page + 1,
							}}
							loading={currencyLoading}
							tableLayout='fixed'
							rowClassName={highlightRow}
						/>
					</StyledPagination>
				</ConfigProvider>
			</div>
		</div>
	);
};

export default Currency;
